/**
 * Session storage key for bulk asset job creation flow
 * Used to pass selected assets and job creation context between components
 */
export const BULK_ASSET_JOB_CREATION_KEY = 'bulkAssetJobCreation';
